import { Injectable, signal } from '@angular/core';
import { Ticket } from 'src/app/models/core/ticket.model';

@Injectable({
    providedIn: 'root'
})
export class TicketStateService {
    // notify when a new ticket is generated
    private _ticketGenerated = signal<Ticket | null>(null);

    // notify when products should be refreshed
    private _shouldRefreshProducts = signal(false);

    // Signal for the specific product that was updated
    private _updatedProductId = signal<number | null>(null);

    // Computed signal to get the generated ticket
    readonly ticketGenerated = this._ticketGenerated.asReadonly();

    // Computed signal to check if products should be refreshed
    readonly shouldRefreshProducts = this._shouldRefreshProducts.asReadonly();

    // Computed signal to get the updated product ID
    readonly updatedProductId = this._updatedProductId.asReadonly();

    /**
     * Notifies that a new ticket has been generated
     * @param ticket The generated ticket
     * @param productId The associated product ID
     */
    notifyTicketGenerated(ticket: Ticket, productId: number) {
        this._ticketGenerated.set(ticket);
        this._updatedProductId.set(productId);
        this._shouldRefreshProducts.set(true);

        setTimeout(() => {
            this.clearTicketGenerated();
        }, 100);
    }

    /**
     * Manually marks whether products should be refreshed
     */
    setShouldRefreshProducts(shouldRefresh: boolean) {
        this._shouldRefreshProducts.set(shouldRefresh);
    }


    /**
     * Clears state after processing the update
     */
    clearTicketGenerated() {
        this._ticketGenerated.set(null);
        this._updatedProductId.set(null);
        this._shouldRefreshProducts.set(false);
    }

    /**
     * Fully resets the service state
     */
    reset() {
        this._ticketGenerated.set(null);
        this._updatedProductId.set(null);
        this._shouldRefreshProducts.set(false);
    }
} 